module.exports = __webpack_public_path__ + "static/media/A8.d001a52d.png";